import { useEffect } from 'react'

import { ButtonSelectControlContent } from '../ButtonSelectControlContent'
import { useSelectContext } from '../Select.hooks'
import { SelectControl } from '../SelectControl'
import { SelectControlContainer } from '../SelectControlContainer'

function ButtonSelectControl({
  Container = SelectControlContainer,
  Content = ButtonSelectControlContent,
  ref,
  refs,
  ...restProps
}) {
  const { blocked, disabled, isOpen } = useSelectContext()

  useEffect(() => {
    if (isOpen) {
      refs.reference.current?.focus()
    }
  }, [isOpen])

  return (
    <SelectControl
      {...restProps}
      Container={Container}
      Content={Content}
      blocked={blocked}
      disabled={disabled}
      ref={ref}
    />
  )
}

export default ButtonSelectControl
